// extracted by mini-css-extract-plugin
module.exports = {"boundary":"InfoTooltip_boundary__eOWio","infoIconButton":"InfoTooltip_infoIconButton__P_yie","inverse":"InfoTooltip_inverse__gJiOV"};